import styled from 'styled-components';

export const StyledBulletList = styled.ul`
    list-style-type: disc;
    padding-left: var(--spacing-6);
    margin-top: 0;
    margin-bottom: var(--spacing-6);

    li {
        margin-bottom: var(--spacing-2);
    }
`;
